import React, { useState } from "react";
import config from "../config";

export default function Profile() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passResponseMessage, setPassResponseMessage] = useState("");
  const [showPassResponse, setPassShowResponse] = useState(false);
  const [passErrorMessage, setPassErrorMessage] = useState("");
  const [passShowError, setPassShowError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a new FormData object
    const formData = new FormData();

    formData.append("currentPassword", currentPassword);
    formData.append("newPassword", newPassword);

    fetch(`${config.apiUrl}adminapi.php?option=7`, {
      method: "POST",
      body: formData,
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok.");
        }
        return response.json();
      })
      .then((data) => {
        // Show the response message temporarily
        if (data.message) {
          setPassResponseMessage(data.message);
          setPassShowResponse(true);
        }

        if (data.error) {
          setPassErrorMessage(data.error);
          setPassShowError(true);
        }

        // Hide the response message after 5 seconds
        setTimeout(() => {
          setPassShowResponse(false);
          setPassResponseMessage("");

          setPassErrorMessage("");
          setPassShowError(false);
        }, 5000);
      })
      .catch((data) => {
        // Handle any errors that occurred during the API request
        setPassErrorMessage(data.error);
        setPassShowError(true);

        console.log(data);
        // Hide the response message after 5 seconds
        setTimeout(() => {
          setPassShowError(false);
          setPassErrorMessage("");
        }, 5000);
      });
  };

  return (
    <>
      <nav className="navbar bg-body-tertiary">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Profile</span>
        </div>
      </nav>
      <div dir="ltr" className="p-3">
        <div className="card col-lg-7">
          <form className="mx-3" onSubmit={handleSubmit}>
            <h3 className="my-4">Change Password</h3>
            <hr />
            <div className="form-group row g-3">
              <div>
                <label htmlFor="currentPassword" className="form-label">
                  Current password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="currentPassword"
                  name="currentPassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="newPassword" className="form-label">
                  New password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="newPassword"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2 my-4">
              <button className="btn btn-primary">Submit</button>
            </div>
            {showPassResponse && (
              <div className="alert alert-success my-2">
                {passResponseMessage}
              </div>
            )}
            {passShowError && (
              <div className="alert alert-danger my-2">{passErrorMessage}</div>
            )}
          </form>
        </div>
      </div>
    </>
  );
}
